module.exports = __webpack_public_path__ + "img/map-near.6b27c0a1.png";